import React, { useContext } from "react";
import { PhotoManagerContext } from "../index";
const warningIcon = require("../../styles/images/warning.svg");
import { Album } from "../types";

type SelfieSearchPreferenceCtaType = {
  source: "breadcrumb" | "photogrid";
  setShowSelfieSearchPreferencePopup: React.Dispatch<
    React.SetStateAction<boolean>
  > | null;
  selectedEventId: number;
  selectedAlbum: Album | null;
};

const SelfieSearchPreferenceCta = ({
  source,
  setShowSelfieSearchPreferencePopup,
  selectedEventId,
  selectedAlbum
}: SelfieSearchPreferenceCtaType) => {
  const context = useContext(PhotoManagerContext);

  const handleClick = (e: React.MouseEvent) => {
    e.stopPropagation();
    setShowSelfieSearchPreferencePopup?.(true);
  };

  if (source == "photogrid") {
    if (selectedAlbum?.canUpdateSelfiePreference) {
      return (
        <>
          <button
            className="geo-btn geo-btn--secondary-link"
            onClick={handleClick}
          >
            Set Selfie Search Preference
          </button>
        </>
      );
    }
    return (
      <div className="upload-cta-info">
        <span className="secondary-text">
          Please contact the event organizer.
        </span>
      </div>
    );
  }
  return (
    <button
      id={`selfie-warning-icon-${selectedEventId}`}
      className="geo-btn geo-btn--small geo-btn--secondary geo-btn--caps ws-upld-btn upld-waning-btn"
      onClick={handleClick}
      data-toggle="tooltip"
      data-placement="bottom"
      onMouseEnter={() =>
        context?.showActionTooltip(
          selectedEventId,
          "Selfie search preference should be set before uploading photos",
          "selfie-warning"
        )
      }
    >
      <img src={warningIcon} alt="warning" />
      Upload Photos
    </button>
  );
};
export default SelfieSearchPreferenceCta;
